import { render, staticRenderFns } from "./outorderWithStandard.vue?vue&type=template&id=9bb2b0f2&scoped=true&"
import script from "./outorderWithStandard.vue?vue&type=script&lang=js&"
export * from "./outorderWithStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bb2b0f2",
  null
  
)

export default component.exports